import React from "react";
import { Box, Stack, Switch } from "@mui/material";
import MyTypography from "./MyTypography";

const LabeledSwitch = ({ withSwitchLabel = false, checked, onChange, header = null, subheader = null, ...others }) => {
  return (
    <Box display="flex" alignItems="center">
      <Stack spacing={1}>
        <MyTypography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
          {header}
        </MyTypography>
        <MyTypography variant="body1">
          {subheader}
        </MyTypography>
      </Stack>

      <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
        {withSwitchLabel && <MyTypography variant="body2" sx={{ fontWeight: !checked ? "bold" : "normal" }}>No</MyTypography>}
        <Switch checked={checked} onChange={onChange} {...others} />
        {withSwitchLabel && <MyTypography variant="body2" sx={{ fontWeight: checked ? "bold" : "normal" }}>Yes</MyTypography>}
      </Box>
    </Box>
  );
};

export default LabeledSwitch;
